//  APIのURLを定義
// const TEST_API = 'http://localhost:8080';
const API = 'https://calm-river-05129.herokuapp.com';

export async function fetchFromAPI(endpoint, opts) {
    // HTTP Methodとbodyを作成
    const { method, body } = {method: 'POST', body: null, ...opts};

    // APIにrequestを行い、レスポンスを獲得
    const respose = await fetch(`${API}/${endpoint}`, {
        method,
        ...(body && {body: JSON.stringify(body)}),
        headers: {
            'Content-Type': 'application/json'
        }
    });

    // レスポンスをJSON形式にして返す
    return respose.json();
}